<script>
  // import { tourConfig as PromiseConfig } from '../tour-config';
  // const tourConfig = Promise.resolve(PromiseConfig);
  export let config;
  const tourConfig = config;

  import { onMount } from "svelte";
  import Loader from "./Loader.svelte";

  export let xml;
  export let logoLoading = "./images/logo.png";
  export let logoLoadingWidth = 500;

  export let colors;

  let krpano;
  window.CC = window.CC || {};
  let krpanoLoading = true;
  function getQueryStrings(allowed = ["startscene", "location"]) {
    const urlParams = new URLSearchParams(window.location.search);
    const queryStrings = {};
    for (const key of allowed) {
      const value = urlParams.get(key);
      if (value) {
        queryStrings[key] = value;
      }
    }
    return queryStrings;
  }

  const queryStrings = getQueryStrings();

  function setKrpano(krpanoHandle) {
    krpano = krpanoHandle;
    window.CC.krpano = krpano;
  }

  function startKrpano() {
    // convert 0x000000 to hex color value
    const hexHotspotTextColor = colors?.hotspotTextColor
      ? colors.hotspotTextColor.replace("0x", "#")
      : "#000000";

    // separate callout color into color and alpha
    const calloutColor = colors?.calloutColor || "0x000000";
    const calloutColorOnly = calloutColor.slice(0, 8);
    const calloutColorAlpha =
      calloutColor.length > 8
        ? parseInt(calloutColor.slice(8), 16) / 255.0
        : 1.0;

    if (typeof embedpano === "function") {
      embedpano({
        xml: xml,
        target: "pano",
        html5: "always",
        passQueryParameters: false, // prevent xss
        onready: setKrpano,
        initvars: {
          hotspotHoverColor: colors?.hotspotHoverColor || "0x000000",
          hexHotspotTextColor,
          calloutColor: calloutColorOnly,
          calloutColorAlpha,
          hasLittlePlanet: tourConfig?.hasLittlePlanet ?? true,
          ...queryStrings,
        },
      });

      krpanoLoading = false;
      return true;
    } else {
      return false;
    }
  }

  onMount(async () => {
    if (xml) {
      // check if the embedpano function exists, and call it when it does.
      let interval = setInterval(() => {
        if (startKrpano()) {
          clearInterval(interval);
        }
      }, 1000);
    }
  });
</script>

<!-- /*____________ Markup ____________*/ -->
<svelte:head>
  <script src={"tour.js"}></script>
</svelte:head>

<Loader
  logo={logoLoading}
  loading={krpanoLoading}
  delay="1000"
  width={logoLoadingWidth}
/>
<div id="pano" class="tour"></div>

<!-- /*____________ CSS ____________*/ -->
<style>
  div.tour {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #000;
  }
</style>
